import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "../page/Dashboard";
import Drivers from "../page/Drivers";
import NFT from "../page/nft";
import Landing from "../page/Landing";
import Login from "../page/Login";
import ForgetPassword from "../page/ForgetPassword";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import ContestPrizes from "../page/Contest&Prizes/contestprizes";
import Rewards from "../page/Rewards/rewards";
import PushNotification from "../page/PushNotification/pushNotification";
import Driver from "../page/Driver";
import Team from "../page/Team";
import PrizeFullfillment from "../page/PrizeFullfillment";
import { useSelector } from "react-redux";
import RoleBaseRoute from "./roleBaseRoute";
import Companies from "../page/Companies";
import Company from "../page/Company";
import Referrals from "../page/Referrals";
import Noonlight from "../page/Noonlight";

const Router = () => {
  const userType = useSelector(
    (state: any) => state?.auth?.loginData?.user_type,
  );
  return (
    <BrowserRouter>
      <Routes>
        {userType === "admin" ? (
          <>
            <Route path="/" Component={PrivateRoute}>
              <Route path="/" Component={Dashboard} />
            </Route>
            <Route path="/drivers" Component={PrivateRoute}>
              <Route path="/drivers/:id" Component={Driver} />
            </Route>
            <Route path="/drivers" Component={PrivateRoute}>
              <Route path="/drivers" Component={Drivers} />
            </Route>
            <Route path="/companies" Component={PrivateRoute}>
              <Route path="/companies/:id" Component={Company} />
            </Route>
            <Route path="/companies" Component={PrivateRoute}>
              <Route path="/companies" Component={Companies} />
            </Route>
            <Route path="/referrals" Component={PrivateRoute}>
              <Route path="/referrals" Component={Referrals} />
            </Route>
            <Route path="/noonlight" Component={PrivateRoute}>
              <Route path="/noonlight" Component={Noonlight} />
            </Route>

            <Route path="/crud" Component={PrivateRoute}>
              <Route path="/crud" Component={Landing} />
            </Route>
            <Route path="/nft" Component={PrivateRoute}>
              <Route path="/nft" Component={NFT} />
            </Route>
            <Route path="/contestandprizes" Component={PrivateRoute}>
              <Route path="/contestandprizes" Component={ContestPrizes} />
            </Route>
            <Route path="/rewards" Component={PrivateRoute}>
              <Route path="/rewards" Component={Rewards} />
            </Route>
            <Route path="/notifications" Component={PrivateRoute}>
              <Route path="/notifications" Component={PushNotification} />
            </Route>
            <Route path="/teamAccess" Component={PrivateRoute}>
              <Route path="/teamAccess" Component={Team} />
            </Route>
            <Route path="/prizeFullfillment" Component={PrivateRoute}>
              <Route path="/prizeFullfillment" Component={PrizeFullfillment} />
            </Route>
          </>
        ) : (
          <>
            <Route path="/prizeFullfillment" Component={PrivateRoute}>
              <Route path="/prizeFullfillment" Component={PrizeFullfillment} />
            </Route>
          </>
        )}
        <Route path="*" Component={PrivateRoute}>
          <Route path="*" Component={RoleBaseRoute} />
        </Route>
        <Route path="/login" Component={PublicRoute}>
          <Route path="/login" Component={Login} />
        </Route>
        <Route path="/forgot-password" Component={PublicRoute}>
          <Route path="/forgot-password" Component={ForgetPassword} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
